/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M6 17H8.5M6 6H18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6 11.5L16.25 11.5C17.7688 11.5 19 12.7312 19 14.25V14.25C19 15.7688 17.7688 17 16.25 17H12M12 17L14 15M12 17L14 19M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M6 17H8.5M6 11.5L16.25 11.5C17.7688 11.5 19 12.7312 19 14.25V14.25C19 15.7688 17.7688 17 16.25 17H12M12 17L14 15M12 17L14 19M6 6H18M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25L14.75 1.25C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27434 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25L22.75 14.75L22.75 14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75L9.25 22.75C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75L1.25 9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27434 3.98005 1.79497ZM6 6.75L18 6.75C18.4142 6.75 18.75 6.41421 18.75 6C18.75 5.58579 18.4142 5.25 18 5.25L6 5.25C5.58579 5.25 5.25 5.58579 5.25 6C5.25 6.41421 5.58579 6.75 6 6.75ZM6 12.25L16.25 12.25L16.2707 12.25C17.3621 12.2541 18.2459 13.1379 18.25 14.2293L18.25 14.25L18.25 14.2707C18.2459 15.3621 17.3621 16.2459 16.2707 16.25L16.25 16.25L13.8107 16.25L14.5303 15.5303C14.8232 15.2374 14.8232 14.7626 14.5303 14.4697C14.2374 14.1768 13.7626 14.1768 13.4697 14.4697L11.4697 16.4697C11.329 16.6103 11.25 16.8011 11.25 17C11.25 17.1989 11.329 17.3897 11.4697 17.5303L13.4697 19.5303C13.7626 19.8232 14.2374 19.8232 14.5303 19.5303C14.8232 19.2374 14.8232 18.7626 14.5303 18.4697L13.8107 17.75L16.25 17.75L16.2763 17.75C18.1918 17.7427 19.7427 16.1918 19.75 14.2763L19.75 14.25L19.75 14.2237C19.7427 12.3082 18.1918 10.7573 16.2763 10.75L16.25 10.75L6 10.75C5.58579 10.75 5.25 11.0858 5.25 11.5C5.25 11.9142 5.58579 12.25 6 12.25ZM6 16.25C5.58579 16.25 5.25 16.5858 5.25 17C5.25 17.4142 5.58579 17.75 6 17.75L8.5 17.75C8.91421 17.75 9.25 17.4142 9.25 17C9.25 16.5858 8.91421 16.25 8.5 16.25L6 16.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9.5 2L9 2V2C7.13872 2 6.20808 2 5.45492 2.24472C3.93273 2.73931 2.73931 3.93273 2.24472 5.45492C2 6.20808 2 7.13872 2 9L2 14C2 16.8003 2 18.2004 2.54497 19.27C3.02434 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V9C22 7.13872 22 6.20808 21.7553 5.45492C21.2607 3.93273 20.0673 2.73931 18.5451 2.24472C17.7919 2 16.8613 2 15 2V2L14.5 2M6 17H8.5M6 11.5L16.25 11.5C17.7688 11.5 19 12.7312 19 14.25V14.25C19 15.7688 17.7688 17 16.25 17H12M12 17L14 15M12 17L14 19M6 6H18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M6 17H8.5M6 11.5L16.25 11.5C17.7688 11.5 19 12.7312 19 14.25V14.25C19 15.7688 17.7688 17 16.25 17H12M12 17L14 15M12 17L14 19M6 6H18M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M18 6.75L6 6.75C5.58579 6.75 5.25 6.41422 5.25 6C5.25 5.58579 5.58579 5.25 6 5.25L18 5.25C18.4142 5.25 18.75 5.58579 18.75 6C18.75 6.41422 18.4142 6.75 18 6.75ZM16.25 12.25L6 12.25C5.58579 12.25 5.25 11.9142 5.25 11.5C5.25 11.0858 5.58579 10.75 6 10.75L16.25 10.75L16.2763 10.75C18.1918 10.7573 19.7427 12.3082 19.75 14.2237L19.75 14.25L19.75 14.2763C19.7427 16.1918 18.1918 17.7427 16.2763 17.75L16.25 17.75L13.8107 17.75L14.5303 18.4697C14.8232 18.7626 14.8232 19.2374 14.5303 19.5303C14.2374 19.8232 13.7626 19.8232 13.4697 19.5303L11.4697 17.5303C11.329 17.3897 11.25 17.1989 11.25 17C11.25 16.8011 11.329 16.6103 11.4697 16.4697L13.4697 14.4697C13.7626 14.1768 14.2374 14.1768 14.5303 14.4697C14.8232 14.7626 14.8232 15.2374 14.5303 15.5303L13.8107 16.25L16.25 16.25L16.2707 16.25C17.3621 16.2459 18.2459 15.3621 18.25 14.2707L18.25 14.25L18.25 14.2293C18.2459 13.1379 17.3621 12.2541 16.2707 12.25L16.25 12.25ZM5.25 17C5.25 16.5858 5.58579 16.25 6 16.25L8.5 16.25C8.91421 16.25 9.25 16.5858 9.25 17C9.25 17.4142 8.91421 17.75 8.5 17.75L6 17.75C5.58579 17.75 5.25 17.4142 5.25 17Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
